export default {
  stageType: Object.freeze({CURRENT_STATE: 'current-state', TREATMENT_PLAN: 'treatment-plan'}),
}
